/**
 * Install App Banner
 * Prompts eligible visitors to add Bubakii OS to their home screen.
 * - Android/Chrome/Edge: captures the native `beforeinstallprompt` event
 *   and triggers it from our own button.
 * - iOS Safari: never fires that event, so we show manual instructions
 *   for the Share -> "Add to Home Screen" flow instead.
 */
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useInstallPrompt } from "../hooks/useInstallPrompt";

function InstallAppBanner() {
  const { canInstallAndroid, showIOSInstructions, promptInstall, dismiss } =
    useInstallPrompt();

  return (
    <Snackbar
      open={canInstallAndroid || showIOSInstructions}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Alert
        severity="info"
        variant="filled"
        action={
          <>
            {canInstallAndroid && (
              <Button color="inherit" size="small" onClick={promptInstall}>
                Install
              </Button>
            )}
            <IconButton
              aria-label="Dismiss"
              color="inherit"
              size="small"
              onClick={dismiss}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
      >
        {canInstallAndroid
          ? "Install Bubakii OS for faster access."
          : 'Tap the Share icon, then "Add to Home Screen" to install Bubakii OS.'}
      </Alert>
    </Snackbar>
  );
}

export default InstallAppBanner;
